import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

function Box({ children }) {
  return (
    <div
      style={{
        display: "block",
        lineHeight: 1,
        width: "100%",
      }}
    >
      {children}
    </div>
  );
}

const MediaSkeleton = ({ isEventPage }) => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const xs = useMediaQuery(theme.breakpoints.down("sm"));

  const containerStyle = {
    display: "flex",
    gap: "24px",
  };

  const skeletonStyle = {
    width: "100%",
    height: md ? 370 : sm ? 250 : 200,
  };

  return (
    <SkeletonTheme
      baseColor="#D8DBE0"
      highlightColor="#EDF1F6"
      borderRadius={"4px"}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "0 16px",
          gap: 24,
        }}
      >
        {!isEventPage && <Skeleton wrapper={Box} width={124} height={16} />}
        <div style={containerStyle}>
          <div style={{ width: xs ? "100%" : "70%" }}>
            <Skeleton style={skeletonStyle} />
          </div>
          {!xs && (
            <div style={{ width: "30%" }}>
              <Skeleton style={skeletonStyle} />
            </div>
          )}
        </div>
      </div>
    </SkeletonTheme>
  );
};

export default MediaSkeleton;
